/**
 * Scope workspace attivo per i moduli herika-admin per-workspace (Pricing/Anagrafiche).
 *
 * Holder singolo per sessione FE: letto dagli interceptor axios (non-React) come
 * header `X-Workspace-Id` e dai componenti via `useActiveWorkspaceId` (subscribe
 * con useSyncExternalStore). `null` = "tutti i workspace" (view-all). Gli id sono
 * gli STESSI `workspace_id` con cui il BE fa l'enforcement (endpoint /workspaces).
 */
import * as React from "react";

export interface WorkspaceRef {
  workspace_id: string;
  workspace_name?: string | null;
  workspace_code?: string | null;
}

export interface MyWorkspaces {
  /** true = admin/membership org-level: vede tutto e in view-all può scrivere (org-generale). */
  unrestricted: boolean;
  workspaces: WorkspaceRef[];
}

let _active: string | null = null;
const _subs = new Set<() => void>();

export function getActiveWorkspaceId(): string | null {
  return _active;
}

export function setActiveWorkspaceId(id: string | null): void {
  if (_active === id) return;
  _active = id;
  _subs.forEach((fn) => fn());
}

function subscribe(cb: () => void): () => void {
  _subs.add(cb);
  return () => _subs.delete(cb);
}

/** Header X-Workspace-Id: l'id attivo, o "all" per il view-all esplicito. */
export function workspaceHeaderValue(): string {
  return _active ?? "all";
}

export function useActiveWorkspaceId(): string | null {
  return React.useSyncExternalStore(subscribe, getActiveWorkspaceId, getActiveWorkspaceId);
}
